module.exports = __webpack_public_path__ + "static/media/clorio-mina-wallet.9dfbde30.svg";